import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Reusable legal links row for footers, login screen, and checkout/payment
 * areas. Keeps the visual treatment lightweight and consistent with the
 * rest of the Harday design language.
 *
 * Props:
 *  - className: optional wrapper className overrides
 *  - align: 'center' | 'left' (default 'center')
 *  - tone: 'muted' | 'subtle' (default 'muted')
 *  - prefix: optional leading text e.g. "By continuing, you agree to our"
 */
const LegalLinks = ({
  className = '',
  align = 'center',
  tone = 'muted',
  prefix = '',
  separator = ' · ',
}) => {
  const baseTextColor = tone === 'subtle' ? 'text-[#9CA3AF]' : 'text-[#666666]';
  const linkColor = 'text-[#9333EA] hover:text-[#7C3AED]';
  const justify = align === 'left' ? 'text-left' : 'text-center';

  return (
    <p
      className={`text-xs font-['DM_Sans'] ${baseTextColor} ${justify} ${className}`}
      data-testid="legal-links"
    >
      {prefix && <span className="mr-1">{prefix}</span>}
      <Link
        to="/terms-and-conditions"
        data-testid="legal-link-terms"
        className={`underline underline-offset-2 ${linkColor} font-medium`}
      >
        Terms &amp; Conditions
      </Link>
      <span className={baseTextColor}>{separator}</span>
      <Link
        to="/privacy-policy"
        data-testid="legal-link-privacy"
        className={`underline underline-offset-2 ${linkColor} font-medium`}
      >
        Privacy Policy
      </Link>
    </p>
  );
};

export default LegalLinks;
